import { useEffect, useRef } from "react";

export const AnimatedGridBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let animationId;
    let dots = [];
    let time = 0;
    const spacing = 40;
    const dotRadius = 1.5;

    const resize = () => {
      canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      canvas.height = canvas.offsetHeight * window.devicePixelRatio;
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
      createDots();
    };

    const createDots = () => {
      dots = [];
      const w = canvas.offsetWidth;
      const h = canvas.offsetHeight;
      for (let x = 0; x < w; x += spacing) {
        for (let y = 0; y < h; y += spacing) {
          dots.push({ x, y, baseX: x, baseY: y });
        }
      }
    };

    const animate = () => {
      const w = canvas.offsetWidth;
      const h = canvas.offsetHeight;
      ctx.clearRect(0, 0, w, h);
      time += 0.005;

      const centerX = w / 2;
      const centerY = h / 2;
      const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY);

      for (let i = 0; i < dots.length; i++) {
        const dot = dots[i];
        const wave = Math.sin(time + i * 0.01) * 3;
        dot.y = dot.baseY + wave;

        const dx = dot.x - centerX;
        const dy = dot.y - centerY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const opacity = 0.3 * (1 - dist / maxDistance);

        if (opacity > 0.02) {
          ctx.beginPath();
          ctx.fillStyle = `rgba(22, 160, 133, ${opacity})`;
          ctx.arc(dot.x, dot.y, dotRadius, 0, Math.PI * 2);
          ctx.fill();
        }
      }

      animationId = requestAnimationFrame(animate);
    };

    resize();
    animate();
    window.addEventListener("resize", resize);

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 z-0 w-full h-full"
      style={{ opacity: 0.4 }}
    />
  );
};
